(function(){
  if(window.__caxInit) return; window.__caxInit=1;
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io=null;

  function countdown(root){
    if(!root) return;
    var dl=new Date(root.getAttribute('data-deadline')).getTime();
    var dEl=root.querySelector('[data-d]'),hEl=root.querySelector('[data-h]'),mEl=root.querySelector('[data-m]');
    if(!dEl) return;
    function tick(){
      var diff=dl-Date.now();
      if(diff<0){dEl.textContent='0';hEl.textContent='0';mEl.textContent='0';return;}
      dEl.textContent=Math.floor(diff/86400000);
      hEl.textContent=Math.floor(diff%86400000/3600000);
      mEl.textContent=Math.floor(diff%3600000/60000);
    }
    tick(); setInterval(tick,30000);
  }

  function reveal(scope){
    /* エディタ(designMode)では非表示にしない＝編集時に消えるのを防ぐ */
    if(prefersReduced || !('IntersectionObserver' in window) || designMode) return;
    document.documentElement.classList.add('cax-anim');
    if(!io){
      io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target);} });
      },{threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    }
    (scope||document).querySelectorAll('.cax-sec').forEach(function(s){ io.observe(s); });
  }

  function init(scope){
    (scope||document).querySelectorAll('.cax-count').forEach(countdown);
    reveal(scope);
  }

  if(document.readyState!=='loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(); }); }

  /* テーマエディタでセクション再描画時に再初期化＋確実に表示 */
  document.addEventListener('shopify:section:load', function(e){
    init(e.target);
    var s=e.target.querySelector('.cax-sec'); if(s){ s.classList.add('is-in'); }
  });
})();